import '../sass/components/Preloader.sass'

export default function Preloader () {
    return (
        <div className="preloader">
            <div className="spinner">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
            </div>
            <p className="loading-text">Загрузка...</p>
        </div>
    );
};